export default "__VITE_ASSET__8e8ef805__"